module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-37-82a4485b9e64eb3fa8eba58c3355885c.jpg";